import React, { useMemo } from 'react';
import LineBandGraphCard from './LineBandGraphCard';
import { Grid } from '@mui/material';
import StatisticsCirclePointsCard from './StatisticsCirclePointsCard';
import { AppColors } from '../../../Utils/helper/AppColors';

const DashboardGraphs = ({trendData,reasonsData}) => {
    
	console.log('trendData in graphs', trendData);
	const trendsDataLineBandGraph = useMemo(() => {
		return trendData?.map(item => ({
			label: item?.date,
			value: item?.score100 || 0,
		})) || [];
	}, [trendData]);

	const reasonsDataCirclePoints = useMemo(() => {
		return reasonsData?.reasons?.map(item => (
			 {
			data : item?.count,
            label: item?.label,
			 }
		)) || [];
	}, [reasonsData]);
	
	console.log('trendsDataLineBandGraph', trendsDataLineBandGraph);
	console.log('reasonsDataCirclePoints', reasonsDataCirclePoints);
	return (
		<Grid container spacing={2}>
			<Grid item xs={8}>
				<LineBandGraphCard
					title="Average Sentimental Score Over Time"
					data={trendsDataLineBandGraph}
					colors={{ line: AppColors?.orange , band: 'rgba(75, 192, 192, 0.2)' }}
					band={2}
				/>
			</Grid>
			<Grid item xs={4}>
				{/* <PeakCallHoursChart  dataPeakChart={trendsData?.peakHours} /> */}
				<StatisticsCirclePointsCard
					title="Reason For Leaving"
					values={reasonsDataCirclePoints.map(item => item.data)} // Example values
					labels={reasonsDataCirclePoints.map(item => item.label)}
					colors={[AppColors?.tomato_orange,AppColors?.orange, AppColors?.yellow]} // Example colors
					total={reasonsData?.total?.reasons || 0}

				/>
			</Grid>
		</Grid>
	);
};

export default DashboardGraphs;
